export default "__VITE_ASSET__DF57bI9j__"